import { get } from 'lodash';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('communities', 'notificationCounters', [
  'UPDATE_COMMUNITY_COUNT',
  'UPDATE_ACTIVITY_COUNT',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'notification_counters',
  type: 'get',
});

const requestReducer = createReqReducer(consts);

export default (state, action) => {
  const { type, payload } = action;
  const change = payload;
  const getPrevCount = param => get(state, param);

  switch (type) {
    case consts.UPDATE_COMMUNITY_COUNT:
      return {
        ...state,
        communityNotificationsCount:
          getPrevCount('communityNotificationsCount') + change,
      };
    case consts.UPDATE_ACTIVITY_COUNT:
      return {
        ...state,
        activityNotificationsCount:
          getPrevCount('activityNotificationsCount') + change,
      };
    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/communities/notificationCounters.js